<template>
  <div>
    <label class="flex justify-start text-total-white p-1" :for="id">{{ label }}</label>
    <div class="flex rounded-xl">
      <vue-tel-input
        v-model="internalValue"
        :placeholder="placeholder"
        :preferred-countries="preferredCountries"
        :default-country="defaultCountry"
        :enabled-flags="true"
        :enabled-country-code="true"
        :input-classes="'flex-grow text-total-white focus:outline-none border-none focus:border-prime-golden p-4'"
        :dropdown-options="{ showDialCodeInSelection: false, showFlags: true }"
        mode="international"
        @valid="onValid"
        @keypress="handleKeyPress"
      />
    </div>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import { computed } from "vue";

export default {
  name: "PhoneInput",
  components: {
    VueTelInput,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "Enter phone number",
    },
    preferredCountries: {
      type: Array,
      default: () => ["us"],
    },
    modelValue: {
      type: String,
      default: "",
    },
    defaultCountry: {
      type: String,
      default: "US",
    },
  },
  emits: ["update:modelValue", "valid"],
  setup(props, { emit }) {
    const internalValue = computed({
      get() {
        return props.modelValue;
      },
      set(value) {
        emit("update:modelValue", value);
      },
    });
    const onValid = (isValid) => {
      emit("valid", isValid);
    };

    return {
      internalValue,
      onValid,
    };
  },
};
</script>

<style scoped>
.custom-dropdown {
  color: #ffffff !important;
}

:deep(.vue-tel-input) {
  color: white !important;
  border: none !important;
  border-radius: 0.75rem !important;
  display: flex !important;
  width: 100% !important;
}
:deep(.vti__country-code) {
  color: #ffffff !important;
  margin-left: 4px;
  font-size: 14px;
}
:deep(.vti__dropdown-list) {
  background-color: #2e2e2e !important;
  border: #2e2e2e !important;
  border-radius: 0.75rem !important;
  width: 15rem !important;
}
:deep(.vti__dropdown-item.highlighted) {
  background-color: #2e2e2e !important;
}

:deep(.vti__dropdown) {
  background-color: #2e2e2e !important;

  padding: 0.75rem !important;
  flex: 0 0 auto;
  border-top-left-radius: 0.75rem !important;
  border-bottom-left-radius: 0.75rem !important;

  width: auto !important;
}
:deep(.last-preferred) {
  border-bottom: none !important;
}
:deep(.vti__dropdown:hover) {
  background-color: #2e2e2e !important;

  padding: 0.75rem !important;
  flex: 0 0 auto !important;
  border-top-left-radius: 0.75rem !important;
  border-bottom-left-radius: 0.75rem !important;

  width: auto !important;
}

:deep(.vti__input) {
  flex-grow: 1 !important;
  min-width: 0 !important;

  padding: 0.75rem !important;
  background-color: #2e2e2e !important;
  border-top-right-radius: 0.75rem !important;
  border-bottom-right-radius: 0.75rem !important;
  color: white !important;
}

:deep(.vti__dropdown-arrow) {
  display: none !important; /* Hide dropdown arrow if needed */
}

/* Optional: Adjust flag size */
:deep(.vti__flag) {
  width: 20px !important; /* Adjust flag width */
}
</style>
